const backgroundColors = [
  // Source: https://flatuicolors.com/palette/in
  '#6d214f', // magenta-purple
  '#b33771', // fiery-fuchsia
  '#fc427b', // sasquatch-socks
  '#fd7272', // georgia-peach
  '#fea47f', // orchid-orange
  '#f97f51', // rich-gardenia
  '#eab543', // honey-glow
  '#f8efba', // sarawak-white-pepper
  '#bdc581', // pine-glade
  '#cad3c8', // falling-star
  '#9aecdb', // oasis-stream
  '#55e6c1', // sweet-garden
  '#58b19f', // keppel
  '#25ccf7', // spiro-disco-ball
  '#1b9cfc', // clear-chill
  '#182c61', // ending-navy-blue
  '#3b3b98', // bluebell
  '#82589f', // highlighter-lavender
  '#d6a2e8', // bright-ube
  '#2c3a47', // ships-officer
];

export default backgroundColors;



// WEBPACK FOOTER //
// ./constants/colors.js